var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTwitterlogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_384_2754)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.3378 19.317L30.3392 32.1923H26.645L19.2996 21.686V21.6853L18.2212 20.143L9.64062 7.8692H13.3348L20.2594 17.7747L21.3378 19.317Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6779 0H4.32209C1.93513 0 0 1.93513 0 4.32209V35.6779C0 38.0649 1.93513 40 4.32209 40H35.6779C38.0649 40 40 38.0649 40 35.6779V4.32209C40 1.93513 38.0649 0 35.6779 0ZM25.5133 33.9208L18.0802 23.1029L8.77392 33.9208H6.3687L17.0122 21.5491L6.3687 6.05868H14.4867L21.5253 16.3025L30.3377 6.05868H32.743L22.5936 17.8566H22.593L33.6313 33.9208H25.5133Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_384_2754"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterlogo);
export default __webpack_public_path__ + "static/media/twitterlogo.6eb5df2e6ba2671d304915a7dea96457.svg";
export { ForwardRef as ReactComponent };